import * as React from 'react';

// tslint:disable:max-line-length
export const KindergartenIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      fillRule="nonzero"
      d="M14.667 1.333c-.623-.622-1.69-.622-2.311 0l-2.312 2.311-2.31-2.31L6.4 2.666l1.156 1.155-1.69 1.69 1.867 1.866L6.49 8.622 4.622 6.756 3.2 8.178l1.867 1.866-1.245 1.245-1.866-1.867-.356.356a2.415 2.415 0 0 0 0 3.466L2.756 14.4a2.415 2.415 0 0 0 3.466 0l5.956-5.956L13.333 9.6l1.334-1.333-2.311-2.311 2.31-2.312c.623-.622.623-1.6 0-2.31z"
    />
  </svg>
);
